import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconHelpBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					stroke="#000"
					strokeWidth={0.8}
					d="M8.144 13.86a4.22 4.22 0 0 1 0-4.004m5.899 5.792a4.44 4.44 0 0 1-4.079 0m5.899-5.792a4.22 4.22 0 0 1 0 4.005M9.964 8.069a4.45 4.45 0 0 1 4.08 0"
				/>
				<path
					stroke="#000"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M16.237 18.434a8.06 8.06 0 0 1-8.466 0m10.93-10.731a7.67 7.67 0 0 1 0 8.31M7.772 5.283a8.06 8.06 0 0 1 8.464 0M5.307 16.014a7.67 7.67 0 0 1 0-8.31"
				/>
				<path fill="#FEFEFE" d="M15.863 9.856a4.33 4.33 0 0 0-1.82-1.787" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M15.863 9.856a4.33 4.33 0 0 0-1.82-1.787"
				/>
				<path fill="#FEFEFE" d="m19.08 7.415-3.217 2.441" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m19.08 7.415-3.217 2.441"
				/>
				<path fill="#FEFEFE" d="m16.53 4.91 2.55 2.505" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m16.53 4.91 2.55 2.505"
				/>
				<path fill="#FEFEFE" d="M14.043 8.069 16.53 4.91" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M14.043 8.069 16.53 4.91"
				/>
				<path fill="#FEFEFE" d="m16.53 18.807-2.487-3.16" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m16.53 18.807-2.487-3.16"
				/>
				<path fill="#FEFEFE" d="m19.08 16.302-2.55 2.505" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m19.08 16.302-2.55 2.505"
				/>
				<path fill="#FEFEFE" d="m15.863 13.86 3.218 2.442" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m15.863 13.86 3.218 2.442"
				/>
				<path fill="#FEFEFE" d="M14.043 15.648a4.35 4.35 0 0 0 1.82-1.787" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M14.043 15.648a4.35 4.35 0 0 0 1.82-1.787"
				/>
				<path fill="#FEFEFE" d="m7.478 18.807-2.551-2.505" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m7.478 18.807-2.551-2.505"
				/>
				<path fill="#FEFEFE" d="m9.964 15.648-2.486 3.159" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m9.964 15.648-2.486 3.159"
				/>
				<path
					fill="#FEFEFE"
					d="M8.144 13.86a4.3 4.3 0 0 0 .773 1.028c.317.311.67.564 1.047.76"
				/>
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M8.144 13.86a4.3 4.3 0 0 0 .773 1.028c.317.311.67.564 1.047.76"
				/>
				<path fill="#FEFEFE" d="m4.927 16.302 3.217-2.441" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m4.927 16.302 3.217-2.441"
				/>
				<path fill="#FEFEFE" d="M8.144 9.856 4.927 7.415" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M8.144 9.856 4.927 7.415"
				/>
				<path fill="#FEFEFE" d="M9.964 8.069a4.36 4.36 0 0 0-1.82 1.787" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="M9.964 8.069a4.36 4.36 0 0 0-1.82 1.787"
				/>
				<path fill="#FEFEFE" d="m7.478 4.91 2.486 3.158" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m7.478 4.91 2.486 3.158"
				/>
				<path fill="#FEFEFE" d="m4.927 7.415 2.55-2.505" />
				<path
					stroke="#DE1B12"
					strokeLinecap="round"
					strokeWidth={0.8}
					d="m4.927 7.415 2.55-2.505"
				/>
			</g>
		</svg>
	);
}
